export default __webpack_public_path__ + "static/airbnb-8-c4f4ebc3a7deb2fa11a8bcbb8255577b.png";